import { render, staticRenderFns } from "./RegulatorAccountMenu.vue?vue&type=template&id=6f60bd80&scoped=true"
import script from "./RegulatorAccountMenu.vue?vue&type=script&lang=ts"
export * from "./RegulatorAccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./RegulatorAccountMenu.vue?vue&type=style&index=0&id=6f60bd80&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60bd80",
  null
  
)

export default component.exports